export default "__VITE_ASSET__PtDwhFCu__"